import Vue from 'vue'
import Vuex from 'vuex'
import Ajax from '@/axios'

Vue.use(Vuex)

// 用户信息
const userInfo = {
	state: {
		userInfo: null,
		menu: null
	},
	getters: {
		getUserInfo(state) {
			if (state.userInfo) {
				return state.userInfo;
			} else {
				return JSON.parse(localStorage.getItem('userInfo'));
			}
		},
		getMenu(state) {
			if (state.menu) {
				return state.menu;
			} else {
				return JSON.parse(localStorage.getItem('menu'));
			}
		}
	},
	mutations: {
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
			localStorage.setItem('userInfo', JSON.stringify(userInfo));
		},
		setMenu(state, menu) {
			state.menu = menu;
			localStorage.setItem('menu', JSON.stringify(menu));
		},
		clearStorage(state) {
			state.userInfo = null;
			state.menu = null;
			localStorage.clear();
		}
	},
	actions: {
		updateUserInfo({ commit, getters }) {
			return new Promise((resolve, reject) => {
				Ajax.get('/account/mydetail/v1').then(res => {
					commit('setUserInfo', res);
					resolve(getters.getUserInfo);
				})
			})
		},
		updateMenu({ commit, getters }) {
			return new Promise((resolve, reject) => {
				// 系统差异
				Ajax.get(`/menu/mymenu/v1`).then(res => {
					commit('setMenu', res);
					resolve(getters.getMenu);
				})
			})
		}
	}
}

// 地图相关配置
// const mapOption = {
// 	state: {
// 		zoom: 16, // 级别
// 		center: null, // 中心点坐标
// 		// mapStyle: 'amap://styles/dark' // 风格
// 		color: '#007ff5', // 地图主要颜色
// 		helpColor: '#ccc' // 地图辅助颜色
// 	},
// 	getters: {
// 		getCenter(state) {
// 			if (state.center) {
// 				return state.center;
// 			} else {
// 				return JSON.parse(sessionStorage.getItem('center'));
// 			}
// 		}
// 	},
// 	mutations: {
// 		setCenter(state, center) {
// 			state.center = center;
// 			sessionStorage.setItem('center', JSON.stringify(center));
// 		}
// 	},
// 	actions: {
// 		updateCenter({ commit, getters }) {
// 			return new Promise((resolve, reject) => {
// 				Ajax.get('/common/chaos-location/v1').then(res => {
// 					commit('setCenter', [res.longitude, res.latitude]);
// 					resolve(getters.getCenter);
// 				})
// 			})
// 		}
// 	}
// }

export default new Vuex.Store({
	state: {
		SYSTEM: process.env.NODE_ENV // 当前系统环境
	},
	modules: {
		userInfo
	}
})
